import React, { useEffect, useRef } from "react";

/**
 * AutoTextarea — auto-resize verticale, interlinea/spaziatura premium per campi descrittivi lunghi.
 * Drop-in replacement di <textarea>. Props: value, onChange, disabled, placeholder, rows (minRows), testid, className
 */
export default function AutoTextarea({ value, onChange, disabled, placeholder, rows = 2, minRows, testid, className = "", ...rest }) {
  const ref = useRef(null);
  const baseRows = minRows || rows;
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = Math.max(el.scrollHeight, 32) + "px";
  }, [value]);
  return (
    <textarea
      ref={ref}
      data-testid={testid}
      disabled={disabled}
      rows={baseRows}
      value={value || ""}
      onChange={(e) => onChange?.(e.target.value)}
      placeholder={placeholder}
      style={{ lineHeight: "1.55", minHeight: baseRows * 22 }}
      className={`w-full px-3 py-2 rounded-lg border border-[#E2E8F0] focus:outline-none focus:border-brand-azure disabled:bg-slate-50 disabled:text-slate-500 text-sm leading-relaxed resize-none overflow-hidden break-words whitespace-pre-wrap ${className}`}
      {...rest}
    />
  );
}
